import { isEqual } from 'lodash-es';
import {
  GeoJSONSource,
  GeoJSONSourceOptions,
  ImageSource,
  ImageSourceOptions,
  RasterSource,
  VectorSource
} from 'mapbox-gl';

import {
  SourceImplWithTiles,
  SourceOptionsWithCoordinates,
  SourceWithCoordinates
} from './Source';

export const updateData = <T extends GeoJSONSourceOptions['data']>(
  source: GeoJSONSource,
  data: T,
  prevData: T
) => {
  if (data && !isEqual(data, prevData)) {
    // @ts-expect-error there might be types mismatch between setData and GeoJSONSourceOptions.data
    source.setData(data);
  }
};

export const updateImage = (
  source: ImageSource,
  props: ImageSourceOptions,
  prevProps: ImageSourceOptions
) => {
  if (
    (props.url || props.coordinates) &&
    (!isEqual(props.url, prevProps.url) ||
      !isEqual(props.coordinates, prevProps.coordinates))
  ) {
    source.updateImage({
      url: props.url,
      coordinates: props.coordinates
    });
  }
};

export const updateTiles = <
  T extends VectorSource['tiles'] | RasterSource['tiles']
>(
  source: SourceImplWithTiles,
  tiles: T,
  prevTiles: T
) => {
  if (tiles && !isEqual(tiles, prevTiles)) {
    source.setTiles(tiles);
  }
};

export const updateUrl = <T extends VectorSource['url'] | RasterSource['url']>(
  source: SourceImplWithTiles,
  url: T,
  prevUrl: T
) => {
  if (url && !isEqual(url, prevUrl)) {
    source.setUrl(url);
  }
};

export const updateCoordinates = <
  T extends SourceOptionsWithCoordinates['coordinates']
>(
  source: SourceWithCoordinates,
  coordinates: T,
  prevCoordinates: T
) => {
  if (coordinates && !isEqual(coordinates, prevCoordinates)) {
    source.setCoordinates(coordinates);
  }
};
